import { ArrowUp } from "lucide-react";

type ScrollUpPageProps = {
  handlePageUp: () => void;
};

const ScrollUpPage = ({ handlePageUp }: ScrollUpPageProps) => {
  return (
    <div
      className="fixed right-8 md:right-16 bg-orange-400 bottom-6 border rounded-full border-orange-400 z-50 cursor-pointer hover:shadow-md transition-shadow animate-bounce"
      onClick={handlePageUp}
    >
      <ArrowUp size={32} color="white" />
    </div>
  );
};

export default ScrollUpPage;
